import { render } from "./StudentsSocialGroupsView.vue?vue&type=template&id=3fbcac17&scoped=true"
import script from "./StudentsSocialGroupsView.vue?vue&type=script&lang=js"
export * from "./StudentsSocialGroupsView.vue?vue&type=script&lang=js"

import "./StudentsSocialGroupsView.vue?vue&type=style&index=0&id=3fbcac17&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fbcac17"]])

export default __exports__